import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
require('dotenv').config();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router future={{ 
        v7_startTransition: true,
        v7_relativeSplatPath: true 
    }}>
        <App />
    </Router>
);
